module.exports = __webpack_public_path__ + "static/logo-taspen-properti-cf5a9da3c2319c7d4b7c1a128f6ee74b.png";